import { createReducer, on } from '@ngrx/store';
import { initialCaensState, ICaensState } from './caens.state';
import {  CaensLoaded } from './caens.actions';

export const initialState: ICaensState = {
  caens: [],
};

const setCaens = (state: ICaensState, { caens }: { caens: any[] }) => ({
  ...state,
  caens: caens
});

const _caensReducer = createReducer<ICaensState>(
  initialCaensState,
  on(CaensLoaded, setCaens),
);

export function caensReducer(state: ICaensState, action): ICaensState {
  return _caensReducer(state, action);
}
